import React from 'react';

const NavItems = ({ navItems, activeItem, handleItemClick, isMobile = false }) => {
  return (
    <>
      {navItems.map((item) => (
        <button
          key={item.name}
          onClick={() => handleItemClick(item.name, item.link)}
          className={`
            ${isMobile
              ? 'w-full text-left px-4 py-3 rounded-md text-sm font-medium hover:text-white'
              : 'px-3 py-2 rounded-full text-label font-medium hover:text-white'
            }
            ${activeItem === item.name 
              ? 'bg-brand-teal-dark text-white' 
              : 'text-white hover:bg-brand-teal-light hover:text-white'
            }
          `}
        >
          {item.name}
        </button>
      ))}
    </>
  );
};

export default NavItems; 